export default {
  id: 11,
  pride: 43008,
  slug: "beyond-books-rule",
  series: "beyond-books",
  category: "novel",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "不止于纸上的故事：鸿律篇",
    en: "Beyond Books: RULE"
  },
  image: require('@/assets/images/bbr_title.webp'),
  descriptionKey: {
    zh: "定稿小说（约2万字），少年保护女友对抗世界危机。已经借助AI动画化了。",
    en: "Finalized novel (~20k words), a boy protects his girlfriend against a world crisis. Already animated with AI."
  },
  date: { year: 2023, month: 2 },
  genres: ["超能力智斗", "都市奇幻", "科幻", "恋爱"],
  themes: ["爱与守护", "牺牲与成长", "命运与抗争"],
  scale: {
    zh: "约 20,000 字",
    en: "Approx. 20,000 words"
  },
  developerNotesKey: {
    zh: "原文处于封存状态，将在同名公众号逐章发布。AI动画化已经暂停，已有的两集可在下方链接观看。",
    en: "The original text is sealed and will be published chapter by chapter on the WeChat Official Account. AI animation is paused, existing episodes can be watched via the link below."
  },
  tags: ["小说", "AI动画"],
  longDescriptionKey: {
    zh: "跟随主角【苏敬峰】的第一视角，你将体验一场为爱与未来而战的奇幻旅程。你将读到他如何运用进入【作者世界】的独特【异能】，与挚爱的【王烛馨】在一次次惨烈且紧张刺激的战斗中，共同对抗接踵而至的危机——从神秘的【时光机】事件，到深不可测的【规律机构】，再到拥有奇异能力的各路强大敌人。见证【王烛馨】在绝境中借【七彩线】觉醒的惊人力量，感受两人在生死考验中不渝的爱情与牺牲。在来自未来的【穿越者】如母亲般的守护下，以及神秘的银发女孩【银】的指引下，故事将引领你通过铭刻着文字的【大理石】，穿梭于现实与展现为【无垠草地】的【光明境】等奇幻空间，并最终触及关乎宇宙秩序的【鸿律】。这不仅是一部充满奇谋险局的冒险史诗，更是一部关于成长、勇气以及爱情能创造奇迹的动人篇章。前两节已【AI动画化】，邀您一同见证这个不止于纸上的故事。而这一切的背后，更隐藏着涉及宇宙宿命、时间循环与【原初人类】奥秘的【宏大暗线】，等待有心的读者一同探索。",
    en: ""
  },
  links: [
    { type: "web", url: "https://tobenot.top/p/story-bb-rule/", textKey: { zh: "在线阅读", en: "Read Online" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1xPFNe1E8T/", textKey: { zh: "动画 Ep1《作者世界》", en: "Animation Ep1: Author's World" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1pdAUe6Enb/", textKey: { zh: "动画 Ep2《时光机事故》", en: "Animation Ep2: Time Machine Accident" } }
  ]
};
